import { useState } from "react";
import { useAddDeviceSiteMutation, useImportOfflineSiteMutation } from "../../../../store/api/admin/adminApiSlice";
import { setBasicDialogOpenFor, setOpenToast } from "../../../../store/helpers/helperReducers";
import { useStoreDispatch } from "../../../../store/hooks";
import { errorMessage } from "../../../../utils/helpers";
import { ISiteOfflineDetails } from "../../../../store/api/devices/types";
import { useSelector } from "react-redux";
import { siteOfflineSelector } from "../../../../store/api/devices/selectors";
import { errorMsgSelector } from "../../../../store/helpers/helperSelectors";
import { prepareOfflineSitePayload } from "../../../../components/Administrations/AccessControls/Authentication/helpers";
import { setFailedBulkUpload, setSelectedBulkFileUpload, setSuccessBulkUplaod } from "../../../../store/api/admin/reducers";
import { setSiteOfflineDevice } from "../../../../store/api/devices/reducers";
import { resetSiteOfflineDetails } from "../../../../components/helpers";
import { DIALOGOPENFOR } from "../../../../globals/globals";

export const useActiveStep = () => {
  const dispatch = useStoreDispatch();
  const [selectedFile, setSelectedFile] = useState<any>(null);
  const [activeStep, setActiveStep] = useState<number>(0);
  const [isBulkUpload, setIsBulkUpload] = useState(false);
  const [importSite] = useImportOfflineSiteMutation();
  const siteOfflineDetails: ISiteOfflineDetails = useSelector(siteOfflineSelector);
  const errorMsg = useSelector(errorMsgSelector);
  const [formData, setFormData] = useState<ISiteOfflineDetails>(siteOfflineDetails);
  const [addOfflineSite] = useAddDeviceSiteMutation();
  const [isLoadingStatus, setIsLoadingStatus] = useState(false);

  const handleBulkUpload = async (file: File) => {
    if (file) {
      //let fileType = file?.type?.split("/")[1];
      //Below the "if" condition, fulfill only if the browser is Mozilla Firefox on a Windows PC and filte type CSV.
      //   if (!!fileType && fileType.toLowerCase() === "vnd.ms-excel") {
      //     fileType = "csv";
      //   }
      const formData = new FormData();
      formData.append("file", file);
      let result: any;
      try {
        result = await importSite({ formData });
        //const offlineSiteResponse = JSON.parse(result?.data)
        console.log("RESPONSE", result)
        if (result?.error || result?.data?.status === 401) throw result?.error;
        if (result?.data?.status === 200 || result?.statusText === "OK") {
          setIsLoadingStatus(false);
          dispatch(setBasicDialogOpenFor(undefined));
          dispatch(setSelectedBulkFileUpload(null));
          if(Array.isArray(result?.data?.validRows) && result?.data?.validRows?.length > 0) {
            dispatch(setSuccessBulkUplaod(result?.data?.validRows || []));
          }
          if(Array.isArray(result?.data?.errors) && result?.data?.errors?.length > 0) {
            dispatch(setFailedBulkUpload(result?.data?.errors || []));
            dispatch(setBasicDialogOpenFor(DIALOGOPENFOR.BULKSTATUSPOP));
          }
          else {
            dispatch(setOpenToast({ openToast: true, toastType: "success", message: "Bulk upload has initiated!" }));
          }
        }
      } catch (error: any) {
        setIsLoadingStatus(false);
        dispatch(setBasicDialogOpenFor(undefined));
        dispatch(setSelectedBulkFileUpload(null));
        dispatch(setOpenToast({ openToast: true, toastType: "error", message: error?.data ? JSON.stringify(error?.data) : errorMessage(error) }));
      }
    }
  };

  const handleAddOfflineSite = async () => {
    if (!Object.values(errorMsg).some((val) => val !== "")) {
      let payload = prepareOfflineSitePayload(siteOfflineDetails);
      let response: any;
      try {
        response = await addOfflineSite(payload);
        if (response?.error || response?.data?.status === 401) throw response?.error;
        if (response?.data?.statusCodeValue === 200 || response?.data?.statusCode === "OK") {
          setIsLoadingStatus(false);
          dispatch(setBasicDialogOpenFor(undefined));
          dispatch(setSiteOfflineDevice({ ...siteOfflineDetails, ...resetSiteOfflineDetails }));
          dispatch(setOpenToast({ openToast: true, toastType: "success", message: "Offline device added successfully!" }));
        }
      } catch (error: any) {
        setIsLoadingStatus(false);
        dispatch(setBasicDialogOpenFor(undefined));
        dispatch(setOpenToast({ openToast: true, toastType: "error", message: error?.data ? JSON.stringify(error?.data) : errorMessage(error) }));
      }
    }
  };

  // const handleValidate = () => {
  //   if(activeStep === 0) {
  //       if(formData.serialNumber) {
  //           if(formData.serialNumber === '') {
  //           setErrMsg({ ...errMsg, serialNumber: `serialNumber is required` })
  //           }
  //           else if(formData.serialNumber.length < 5){
  //               setErrMsg({ ...errMsg, serialNumber: `serialNumber should be greater than 5` })
  //           }
  //           else setErrMsg({ ...errMsg, serialNumber: ``})
  //       }
  //   }
  // }

  return {
    activeStep,
    setActiveStep,
    isBulkUpload,
    setIsBulkUpload,
    handleBulkUpload,
    formData,
    setFormData,
    selectedFile,
    setSelectedFile,
    handleAddOfflineSite,
    isLoadingStatus, 
    setIsLoadingStatus
  };
};
